import { HeaderService } from '../../../shared/services/header.service';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { Routes } from '../../../shared/utils/routes';
import { HeaderPattern } from '../../../shared/utils/header-list';
import config from '../../../configuration/config.json';
import { headerLists } from '../../../configuration/header-list';
import { MenuItem } from "primeng/api";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Button } from "primeng/button";
import { CommonModule } from "@angular/common";
import { Menu } from "primeng/menu";
import { TooltipDirective } from "ngx-bootstrap/tooltip";

@Component( {
  selector: 'dynamica-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    Button,
    Menu,
    RouterModule,
    TooltipDirective
  ],
  styleUrls: ['./header.component.scss']
} )
export class HeaderComponent implements OnInit, OnDestroy {
  headerItem: HeaderPattern;
  moduleHeaderItem$: Subscription;
  activatedTab: number;
  headerLinks: HeaderPattern[] = [];
  configuration: WritableSignal<typeof config> = signal( config );
  latestDate: string | null;
  menuList: MenuItem[] | undefined;

  constructor(
    private headerService: HeaderService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.moduleHeaderItem$ = this.headerService.moduleHeaderItem.subscribe( ( res: any ) => {
      if( res ) {
        this.headerItem = res;
        this.activatedTab = res.tabs.findIndex( tab => tab.active );
      }
    } );

    this.headerLinks = headerLists.map( item => {
      return {
        ...item,
        path: item.path,
        title: item.title,
        icon: item.icon,
        subMenu: null,
        hasRole: item.role.some( ele => this.authService.getRoles().includes( ele ) ) && item.isEnabled
      }
    } );

    setTimeout( () => {
      this.menuList = [
        {
          label: this.translate.instant( 'sidebar.pricing_rules' ),
          icon: 'bi bi-diagram-2-fill',
          routerLink: Routes.AutoConfirm,
        },
        {
          label: this.translate.instant( 'sidebar.logout' ),
          icon: 'bi bi-box-arrow-right',
          command: () => {
            this.logout();
          }
        }
      ];
    }, 200 );
  }

  navigateAutoConfirmUrl() {
    this.router.navigate( [Routes.AutoConfirm] );
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.moduleHeaderItem$.unsubscribe();
  }
}
